export const clone = <T>(data: T): T => JSON.parse(JSON.stringify(data));
export const isSame = <T>(a: T, b: T): boolean =>
  JSON.stringify(a) === JSON.stringify(b);

export function areFiltersApplied(
  filters: Record<string, any>,
  enabledKeys?: string[],
): boolean {
  const keysToCheck = enabledKeys
    ? Object.keys(filters).filter(fKey => enabledKeys.includes(fKey))
    : Object.keys(filters);

  return keysToCheck.some(fKey => isFilterActive(filters[fKey]));
}

function isFilterActive(filterValue: any): boolean {
  return Array.isArray(filterValue) ? !!filterValue.length : !!filterValue;
}
